// @flow
import React, { Fragment } from 'react';
import MainMobileHeadContainer from 'containers/main/MainMobileHeadContainer';
import MainHeadContainer from 'containers/main/MainHeadContainer';
import MainMobileFooter from 'components/main/MainMobileFooter';
import PostViewer from 'containers/post/PostViewer';
import { type Match } from 'react-router-dom';
import PostCommentsContainer from 'containers/post/PostCommentsContainer';
import PostSequencesContainer from 'containers/post/PostSequencesContainer';
import PlainTemplate from 'components/common/PlainTemplate';
import PageTemplate from 'components/base/PageTemplate';

type Props = {
  match: Match,
};

const Post = ({ match }: Props) => {
  const { username, urlSlug } = match.params;

  return (
    <PageTemplate>
      <header>
        <MainHeadContainer />
        <MainMobileHeadContainer />
      </header>
      <PlainTemplate>
        <PostViewer username={username} urlSlug={decodeURI(urlSlug || '')} />
        <PostCommentsContainer />
      </PlainTemplate>
      <PostSequencesContainer username={username || ''} />
      <MainMobileFooter />
    </PageTemplate>
  );
};

export default Post;



// WEBPACK FOOTER //
// ./src/pages/Post.js